/** Normalize list payloads from our API (array or `{ data: [] }`). */
export function extractApiList(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
}
